<template>
  <ons-page id="splash">
  	<v-ons-progress-bar indeterminate></v-ons-progress-bar>
  	<div style="height: 100%; justify-content: center; align-items: center; display: flex;">{{ $t("messages.loading_current_user") }}</div>
  </ons-page>
</template>

<script>
export default {
  name: 'splash',
};
</script>
